<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cd"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Código</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ / CPF</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="nome"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Razão Social/Nome</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="inscricao_estadual"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Inscrição Estadual</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="municipio"
              :options="this.$parent.optionsMunicipio"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Município"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="status"
              :options="this.$parent.optionsLivStatusFilter"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="fornecedor"
              :options="this.$parent.optionsLivFornecedorFilter"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Fornecedor"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="status_erp"
              :options="this.$parent.optionsStatusErp"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status ERP"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="tp_pessoa"
              :options="this.$parent.optionsTpPessoa"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo Pessoa"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_situacao"
              :options="this.$parent.optionsTpSituacao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Situação"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data expiração Inicial"
              v-model="dt_expiracao_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data expiração Final"
              v-model="dt_expiracao_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  data() {
    return {
      cd: "",
      nome: "",
      cnpj: "",
      inscricao_estadual: "",
      status_erp: "",
      dt_expiracao_ini: "",
      dt_expiracao_fim: "",
      dt_expiracao_ini_label: "",
      dt_expiracao_fim_label: "",
      tp_situacao: "",
      status: [],
      tp_pessoa: [],
      municipio: [],
      fornecedor: [],
      data_filter: [],
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },

  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.dt_expiracao_ini_label = this.dt_expiracao_ini;
      this.dt_expiracao_fim_label = this.dt_expiracao_fim;
      this.dt_expiracao_ini = this.formatDateSubmit(this.dt_expiracao_ini);
      this.dt_expiracao_fim = this.formatDateSubmit(this.dt_expiracao_fim);
      this.data_filter = {
        cd: this.cd,
        cnpj: this.cnpj,
        nome: this.nome,
        tp_situacao: this.tp_situacao,
        dt_expiracao_ini: this.dt_expiracao_ini,
        dt_expiracao_fim: this.dt_expiracao_fim,
        tp_pessoa: this.tp_pessoa,
        inscricao_estadual: this.inscricao_estadual,
        status_erp: this.status_erp,
        status: this.status,
        municipio: this.municipio,
        fornecedor: this.fornecedor,
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_expiracao_ini = this.dt_expiracao_ini_label;
      this.dt_expiracao_fim = this.dt_expiracao_fim_label;
    },
    resetFilter() {
      this.cd = "";
      this.tp_pessoa = "";
      this.cnpj = "";
      this.nome = ""; // clear the text in text input
      this.inscricao_estadual = "";
      this.status_erp = "";
      this.dt_expiracao_ini = "";
      this.dt_expiracao_fim = "";
      this.tp_situacao = "";
      this.status = "";
      this.fornecedor = "";
      this.municipio = "";
      this.$parent.$refs.vuetable.selectedTo = [];
      this.$events.fire("filter-reset");
    },
    formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
      return (value == null || value == "")
          ? ''
          : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
